module.exports = __webpack_public_path__ + "img/pay.348681cf.jpg";